import { getSvgViewBoxSize } from "@components/Atoms/Image/modalImage/getSvgAspectRatio";

const SVG_SCALE = 2;

const loadImage = (src: string): Promise<HTMLImageElement> =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.crossOrigin = "anonymous";
		image.onload = () => resolve(image);
		image.onerror = () => reject(new Error("image failed to load"));
		image.src = src;
	});

const drawToPng = (image: HTMLImageElement, width: number, height: number): Promise<Blob> =>
	new Promise((resolve, reject) => {
		const canvas = document.createElement("canvas");
		canvas.width = Math.round(width);
		canvas.height = Math.round(height);
		canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
		canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("image has no size"))), "image/png");
	});

const rasterizeSvg = async (svg: string): Promise<Blob> => {
	const url = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml" }));
	try {
		const image = await loadImage(url);
		const size = getSvgViewBoxSize(svg) ?? { width: image.naturalWidth, height: image.naturalHeight };
		return await drawToPng(image, size.width * SVG_SCALE, size.height * SVG_SCALE);
	} finally {
		URL.revokeObjectURL(url);
	}
};

const rasterizeImage = async (src: string): Promise<Blob> => {
	const image = await loadImage(src);
	return drawToPng(image, image.naturalWidth, image.naturalHeight);
};

const renderMediaToPng = ({ src, svg }: { src?: string; svg?: string }): Promise<Blob> =>
	svg ? rasterizeSvg(svg) : rasterizeImage(src);

export default renderMediaToPng;
